import { SectionProps } from "./sectionInterface";
import DataRenderer from "../../render";
import SubQuestion from "./common/subQuestion";
import QuestionData from "./common/questionData";

export default function LongAnswerQuestions(props: SectionProps) {

    const { question } = props;
    return (
        <div className="question">

            {
                question.is_question_alternative &&
                <>
                    <span className="question_choice_text">OR</span>
                </>
            }

            {
                question.importance === 'very_important' ?
                    <span className="importance_badge very_imp">🔥 Very Important 🔥</span>
                    :
                    question.importance === 'important' &&
                    <span className="importance_badge very_imp">Important</span>
            }

            <h3 className="question_text">
                {
                    question.is_question_alternative ?
                        <span className="question_number alt">Q{question.question_number}.</span>
                        :
                        <span className="question_number">Q{question.question_number}.</span>
                }
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <DataRenderer text={question.question_text} type='mathpix' />
                    {question.sub_question && question.sub_question.length > 0 &&
                        <SubQuestion question={question} />
                    }
                </div>
            </h3>
            <QuestionData question={question} />
        </div>
    )
}